import { initializeApp } from "firebase/app";
import { firebaseConfig } from "../secret/secret";
import { doc, getDoc, getFirestore, setDoc, updateDoc, where, writeBatch } from "firebase/firestore";
import { collection, getDocs } from "firebase/firestore";
import { query, orderBy } from "firebase/firestore";

import { getAuth, GoogleAuthProvider, onAuthStateChanged, signInWithEmailAndPassword, signInWithPopup } from "firebase/auth";
import { getFunctions, httpsCallable } from 'firebase/functions';
import { api } from "../api-laravel";
import { makeChunks } from "../../utils/firebase/firebase-utils";



// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional



//todo

//сделать enum с названиями коллекций
//TS must be here



// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const firestore = getFirestore(app);


export const clientAPI = {

  create: async (name, email, domain, placementKey, hookKey) => {

    console.log('name', 'email', 'domain', 'placementKey', 'hookKey')
    console.log(name, email, domain, placementKey, hookKey)

    try {
      const addClient = httpsCallable(functions, 'setNewClient');
      let client = await addClient({ name, email, domain, placementKey, hookKey })


      // const sendNewClientEmailHTMLTEST = httpsCallable(functions, 'sendNewClientEmailHTMLTEST');
      // await sendNewClientEmailHTMLTEST({ name, email, domain, placementKey, hookKey })

      console.log(client.data)
      return client.data
    } catch (error) {
      console.log(error)
      let message = 'client was not created'
      alert(message)
      if (error.message) {
        message = error.message
      }
      let response = {
        resultCode: 1,
        message
      }
      return response
    }

  },

  updateClient: async (client) => {

    let result
    let clientId = client && client.number
    try {

      const queryGet = query(collection(db, "clients"), where("number", "==", clientId));
      const querySnapshot = await getDocs(queryGet);


      let searchingClient

      querySnapshot.forEach((client) => {
        if (client.data().number === clientId) {

          searchingClient = doc(db, "clients", client.id);

        }
      });


      await updateDoc(searchingClient, { ...client });

      const resultClientsFetch = query(collection(db, "clients"), where("number", "==", clientId));
      const resultClients = await getDocs(resultClientsFetch);


      resultClients.forEach((doc) => {
        if (doc.data().number === clientId) {
          result = doc.data()
        }
      });

      if (result && result.number) {
        return { resultCode: 0, client: result }
      } else {
        return { resultCode: 1, message: 'client is no updated' }
      }

    } catch (error) {

      return { resultCode: 1, message: error.message && 'client is no updated' }

    }
  },

  getClients: async () => {
    let result = []
    try {
      const queryGet = query(collection(db, "clients"), orderBy("name"));
      const querySnapshot = await getDocs(queryGet);


      querySnapshot.forEach((doc) => {
        let data = doc.data()
        result.push(data)

      });
      console.log('get clients')
      console.log(result)

      return result
    } catch (error) {
      console.log(error)
      return result

    }


  },

  getClient: async (userId) => {
    let result = undefined
    try {

      const queryGet = query(collection(db, "clients"), where("userId", "==", userId));
      const querySnapshot = await getDocs(queryGet);


      querySnapshot.forEach((doc) => {
        if (doc.data().userId === userId) {
          result = doc.data()
        }
      });
      return result
    } catch (error) {
      console.log(error)
      return result

    }


  },

  setProducts: async (clientId, products) => {
    let result
    try {

      const queryGet = query(collection(db, "clients"), where("number", "==", clientId));
      const querySnapshot = await getDocs(queryGet);


      let searchingClient

      querySnapshot.forEach((client) => {
        if (client.data().number === clientId) {
          // result = client.data()
          searchingClient = doc(db, "clients", client.id);

        }
      });


      await updateDoc(searchingClient, { products });

      const resultClientsFetch = query(collection(db, "clients"), where("number", "==", clientId));
      const resultClients = await getDocs(resultClientsFetch);


      resultClients.forEach((doc) => {
        if (doc.data().number === clientId) {
          result = doc.data()
        }
      });
      return result
    } catch (error) {
      console.log(error)
      return result

    }
  },

  updateFields: async (fields, clientId) => {



    let result
    try {

      const queryGet = query(collection(db, "clients"), where("number", "==", clientId));
      const querySnapshot = await getDocs(queryGet);


      let searchingClient

      querySnapshot.forEach((client) => {
        if (client.data().number === clientId) {
          // result = client.data()
          searchingClient = doc(db, "clients", client.id);

        }
      });


      await updateDoc(searchingClient, { fields });

      const resultClientsFetch = query(collection(db, "clients"), where("number", "==", clientId));
      const resultClients = await getDocs(resultClientsFetch);


      resultClients.forEach((doc) => {
        if (doc.data().number === clientId) {
          result = doc.data()
        }
      });
      return result
    } catch (error) {
      console.log(error)
      return result

    }
  },

  updateClientsProducts: async (newProductData) => {

    // Получаем все документы из коллекции "clients"
    const queryGet = query(collection(db, "clients"), orderBy("name"));
    const clientsSnapshot = await getDocs(queryGet);

    // Перебираем каждый документ (клиента) в коллекции



    clientsSnapshot.docs.forEach(async (clientDoc) => {
      // Получаем ссылку на коллекцию продуктов текущего клиента
      const productsRef = collection(doc(db, 'clients', clientDoc.id), 'products');
      const productsSnapshot = await getDocs(productsRef);

      // Перебираем каждый продукт и обновляем его данные
      productsSnapshot.docs.forEach(async (productDoc) => {
        await setDoc(doc(productsRef, productDoc.id), newProductData, { merge: true });
      });
    });



    const updatequeryGet = query(collection(db, "clients"), orderBy("name"));
    const updateclientsSnapshot = await getDocs(updatequeryGet);

    // Перебираем каждый документ (клиента) в коллекции
    let result = []
    updateclientsSnapshot.forEach((doc) => {
      let data = doc.data()
      result.push(data)

    });


    return result

  },

  getProducts: async (clientId) => {
    let client = null
    let id = null
    let products = []

    try {
      const clientsQuery = query(collection(db, "clients"), where("number", "==", clientId));
      const clientsQueryuerySnapshot = await getDocs(clientsQuery);


      clientsQueryuerySnapshot.forEach((doc) => {
        if (doc.data().number === clientId) {
          client = doc.data()
          id = doc.id
        }
      });


      // const querySnapshot = await getDocs(collection(db, "fields"), orderBy("number"));
      const queryGet = query(collection(db, "ClientProducts"), where("clientId", "==", id));
      const querySnapshot = await getDocs(queryGet);

      querySnapshot.forEach((doc) => {
        let data = doc.data()

        products.push(data)
      });

      return products
    } catch (error) {

      console.log(error)
    }

    return products
  },

  setRegions: async (regions, clientId) => {
    let result = undefined
    try {

      const queryGet = query(collection(db, "clients"), where("number", "==", clientId));
      const querySnapshot = await getDocs(queryGet);


      querySnapshot.forEach((doc) => {
        if (doc.data().number === clientId) {
          result = doc.data()
        }
      });
      return result
    } catch (error) {
      console.log(error)
      return result

    }

  },

  updateClientsContracts: async (newContracts) => {
    let result = null
    // Получаем все документы из коллекции "clients"
    const queryGet = query(collection(db, "clients"), orderBy("name"));
    const clientsSnapshot = await getDocs(queryGet);

    // Перебираем каждый документ (клиента) в коллекции



    clientsSnapshot.docs.forEach(async (clientDoc) => {

      // Получаем ссылку на коллекцию продуктов текущего клиента
      let clientData = clientDoc.data();
      let clientContracts = clientData.contracts.items;

      // Обновляем контракты если пришли такие же как уже есть: 
      // Перебираем каждый контракт клиента и обновляем его данные
      let updatedContracts = clientContracts.map((clientContract) => {
        let newContract = newContracts.find(c => c.number === clientContract.number);
        if (newContract) {
          return {
            ...newContract,
            itemId: clientContract.itemId,
            measureId: clientContract.measureId,
            measureCode: clientContract.measureCode,
          }
        }
        // Если нет нового контракта, возвращаем старый без изменений
        return clientContract;
      });
      //перебираем новые контракты
      newContracts.forEach(c => {
        //если такого контракта у клиента нет
        let isHaveContract = updatedContracts.find(uc => uc.number == c.number)
        console.log('isHaveContract')
        console.log(isHaveContract)

        if (!isHaveContract) {
          //пушим контракт к клиенту 
          updatedContracts.push(c)
        }
      })
      // Обновляем поле contracts.items у клиента
      await updateDoc(doc(db, 'clients', clientDoc.id), { 'contracts.items': updatedContracts });


    });



    const resultClientsQueryGet = query(collection(db, "clients"), orderBy("name"));
    const resultClientsQuerySnapshot = await getDocs(resultClientsQueryGet);

    result = []
    resultClientsQuerySnapshot.forEach((doc) => {
      let client = doc.data()

      result.push({
        clientDomain: client.domain,
        newContracts: client.contracts,
      })

    });

    console.log(result)
    console.log('result')
    return result

  },

  clientFieldsGenerate: async () => {


    // const testFunction = httpsCallable(functions, 'clientFieldsGenerate');
    try {

      const test = await generalAPI.clientFieldGenerate()

      console.log(test)
    } catch (error) {
      console.log(error)

    }


  }
}

export const generalAPI = {
 

  setDoc: async (collectionName, document) => {


    let result = null
    try {
      const ref = doc(db, collectionName, document.id);
      await setDoc(ref, document)
      const docSnap = await getDoc(ref);

      if (docSnap.exists()) {
        let newDocument = docSnap.data()

        return newDocument

      } else {
        // docSnap.data() will be undefined in this case
        console.log("No such document!");
      }


      return result
    } catch (error) {

      console.log(error)
      return result

    }


  },
  getDoc: async (collectionName, property, value) => {


    let result = null
    try {

      const queryGet = query(collection(db, collectionName), where(property, "==", value));
      const querySnapshot = await getDocs(queryGet);

      querySnapshot.forEach((doc) => {
        result = doc.data()
      });

      return result
    } catch (error) {

      console.log(error)
      return result

    }


  },

  getCollection: async (collectionName) => {

    let result = []
    debugger
    try {
      // const querySnapshot = await getDocs(collection(db, "fields"), orderBy("number"));
      const queryGet = query(collection(db, collectionName));
      const querySnapshot = await getDocs(queryGet);

      querySnapshot.forEach((doc) => {
        let data = doc.data()

        result.push(data)
      });
      debugger
      return result
    } catch (error) {
      debugger
      console.log(error)
      return result
    }
  },

  setCollection: async (collectionName, objects) => {

    try {


      let docRef = null




      const chunks = makeChunks(objects, 500);
      for (let i = 0; i < chunks.length; i++) {

        const batch = writeBatch(db)
        chunks[i].forEach((element) => {
          let number = element.number ? `${element.number}` : null
          docRef = docRef = doc(db, collectionName, `${element.number}`);
          batch.set(docRef, element, `${element.number}`)

        });
        await batch.commit();
      }
      let result = await generalAPI.getCollection(collectionName)

      return result


    } catch (error) {

      console.error(error)
    }
  },

  setCollectionUniqueId: async (collectionName, objects) => {

    try {


      let docRef = null
      const chunks = makeChunks(objects, 500);
      for (let i = 0; i < chunks.length; i++) {

        const batch = writeBatch(db)
        chunks[i].forEach((element) => {
          // Получите ссылку на коллекцию
          const collectionRef = collection(db, collectionName);
          // Создайте новую ссылку на документ в этой коллекции без указания ID
          const docRef = doc(collectionRef);
          // Используйте эту ссылку в пакетной записи
          batch.set(docRef, element);

        });
        await batch.commit();
      }
      let result = await generalAPI.getCollection(collectionName)

      return result


    } catch (error) {

      console.error(error)
    }
  },

  updateProp: async (collectionName, docId, newProp, propName) => {



    let result
    try {

      const queryGet = query(collection(db, collectionName), where("number", "==", docId));
      const querySnapshot = await getDocs(queryGet);


      let searchingClient

      querySnapshot.forEach((client) => {
        if (client.data().number === docId) {
          // result = client.data()
          searchingClient = doc(db, collectionName, client.id);

        }
      });


      await updateDoc(searchingClient, { [`${propName}`]: newProp });

      const resultClientsFetch = query(collection(db, collectionName), where("number", "==", docId));
      const resultDocs = await getDocs(resultClientsFetch);


      resultDocs.forEach((doc) => {
        if (doc.data().number === docId) {
          result = doc.data()
        }
      });

      return result
    } catch (error) {

      console.log(error)
      return result

    }
  },

  updatetCollection: async (collectionName, objects) => {

    try {


      let docRef = null




      const chunks = makeChunks(objects, 500);
      for (let i = 0; i < chunks.length; i++) {

        const batch = writeBatch(db)
        chunks[i].forEach((element) => {
          docRef = docRef = doc(db, collectionName, `${element.number}`);
          batch.set(docRef, element, `${element.number}`)
        });
        await batch.commit();
      }

      let result = await generalAPI.getCollection(collectionName)

      return result


    } catch (error) {

      console.error(error)
    }
  },

  updateFrontend: async (isProd) => {
    try {
      let response = api.get(`${isProd}`)
      if (response) {
        return response
      }
    } catch (error) {
      console.log(error)
    }

  },

  clientFieldGenerate: async () => {
    let clients = await generalAPI.getCollection('clients')
    let fields = await generalAPI.getCollection('fields')
    let clientFields = []


    clients.forEach((client) => {



      fields.forEach((field) => {

        let isEditable = field.isEditableBitrix == true || field.isEditableValue == true
        let tempClientField = client.fields.find(f => f.number === field.number)

        let customBirixId = tempClientField ? tempClientField.bitrixId : field.bitrixId
        let customValue = tempClientField ? tempClientField.value : field.value
        let number = `${client.number}.${field.number}`

        if (isEditable) {
          let clientField = {
            number,
            fieldNumber: field.number,
            clientNumber: client.number,
            properties: {
              bitrixId: customBirixId,
              value: customValue
            },
            currentCustomProperties: [
              'bitrixId', 'value'
            ]


          }
          clientFields.push(clientField);



        }



      })



    })


    let result = await generalAPI.setCollectionUniqueId('clientFields', clientFields)

    return result

  },
}




export const authApi = {
  getAuth: async () => {
    const provider = new GoogleAuthProvider();
    const auth = getAuth(app);
    let user = auth.currentUser;


    if (!user) {
      auth.languageCode = 'ru';

      await signInWithPopup(auth, provider)
        .then((result) => {
          // This gives you a Google Access Token. You can use it to access the Google API.
          // const credential = GoogleAuthProvider.credentialFromResult(result);
          // const token = credential.accessToken;
          // The signed-in user info.
          user = result.user;
          // resultUser = user.name
          // IdP data available using getAdditionalUserInfo(result)
          // ...




          console.log(user)

          return user

        }).catch((error) => {

          // Handle Errors here.
          // const errorCode = error.code;
          const errorMessage = error.message;
          // The email of the user's account used.
          // const email = error.customData.email;
          // The AuthCredential type that was used.
          const credential = GoogleAuthProvider.credentialFromError(error);
          console.log(errorMessage)
          console.log(credential)

        });



      //todo login with google data?


    }

    return user

  },

  getCurrentUser: async () => {
    const auth = getAuth();
    let resultUser = null
    onAuthStateChanged(auth, (user) => {
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/auth.user
        // const uid = user.uid;
        resultUser = user

        // ...
      } else {
        // User is signed out
        // ...
      }

    });

    return resultUser
  },

  async login(email, password) {

    const auth = getAuth();
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // Signed in 
        const user = userCredential.user;
        console.log(user)
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(error.message)
      });

  },


}
